import { SIMULACAO_MARCA } from "@/modules/recursos/simulacao";
import type { LegendaSimuladoProps, LegendaSimuladoViewModel } from "./types-legenda-simulado";

/** O rótulo é "Alterado na simulação" nas três perspectivas (HU 2225); só a amostra muda. */
export function useLegendaSimulado({
  className,
  preenchida = false,
}: LegendaSimuladoProps): LegendaSimuladoViewModel {
  return {
    className,
    amostra: preenchida ? "simulado-preenchido" : "simulado",
    rotulo: SIMULACAO_MARCA,
  };
}
